const isPortalConnectedToWebsite = ({ data, }) => (data === null || data === void 0 ? void 0 : data.portalIsConfigured) === true ||
    (Array.isArray(data === null || data === void 0 ? void 0 : data.portalIsConfigured) &&
        data.portalIsConfigured.includes(true));
export default isPortalConnectedToWebsite;
